import { render, staticRenderFns } from "./GridRank.vue?vue&type=template&id=181752c0&scoped=true&"
import script from "./GridRank.vue?vue&type=script&lang=js&"
export * from "./GridRank.vue?vue&type=script&lang=js&"
import style0 from "./GridRank.vue?vue&type=style&index=0&id=181752c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181752c0",
  null
  
)

export default component.exports